module.exports = [
  'AS',
  'AC',
  'AD',
  'AH',
  'KS',
  'KC',
  'KD',
  'KH',
  'QS',
  'QC',
  'QD',
  'QH',
  'JS',
  'JC',
  'JD',
  'JH',
  'TS',
  'TC',
  'TD',
  'TH',
  '9S',
  '9C',
  '9D',
  '9H',
  '8S',
  '8C',
  '8D',
  '8H',
  '7S',
  '7C',
  '7D',
  '7H',
  '6S',
  '6C',
  '6D',
  '6H',
  '5S',
  '5C',
  '5D',
  '5H',
  '4S',
  '4C',
  '4D',
  '4H',
  '3S',
  '3C',
  '3D',
  '3H',
  '2S',
  '2C',
  '2D',
  '2H',
];
